import CallAPI from "../../utility/functions/getData";
import {
  setAlertWithTitle,
  setSpinnerLoading,
} from "../../utility/Redux/modal";
import dataToLocal from "../../utility/component/dataToLocal";
import deleteWholeDatabase from "../../utility/functions/deleteWholeDatabase";

export const GetPurchaseSummary = (data, token, dispatch, setPurchaseList,setTotalPages,setCurrentPage) => {
  dispatch(setSpinnerLoading("Loading"));
  deleteWholeDatabase("item_expiry_report");
  CallAPI(
    "/api/expiry/listExpiry",
    data,
    token,
    (e) => {
      if (!e.data.error) {
setTotalPages(e.data.response.totalPages)
setCurrentPage(e.data.response.currentPage)
        const res = e.data.response.data;
        if (res[0]) {
          setPurchaseList(res);
          dataToLocal("item_expiry_report", res, [
            {
              ...data,
              ICODE: 1,
            },
          ]);
        } else {
          setPurchaseList([]);

          dispatch(
            setAlertWithTitle({
              title: "Alert",
              msg: "No Records found",
            })
          );
        }
      } else {
        dispatch(
          setAlertWithTitle({
            title: "Alert",
            msg: "Something Went Wrong.",
          })
        );
      }
    },
    dispatch,
    () => {
      dispatch(setSpinnerLoading(false));
    }
  );
};
